import {
  gql,
  LazyQueryHookOptions,
  OperationVariables,
  useLazyQuery,
} from '@apollo/client';

/**
 * Lightweight query to fetch only detection IDs for "Select All" functionality
 * Uses the same filter/query params as the main detections query but only returns IDs
 */
export const QUERY_DETECTION_IDS = gql`
  query queryDetectionIds($query: String, $sort: [SortParameterInput]) {
    queryDetectionsPaginated(
      query: $query
      offset: 0
      size: 10000
      sort: $sort
    ) {
      detections {
        detection_id
        tenant
      }
      total_items
    }
  }
`;

export interface QueryDetectionIdsVariables extends OperationVariables {
  query: string;
  sort?: Array<{ sort_by: string; sort_dir: string }>;
}

export interface QueryDetectionIdsResponse {
  queryDetectionsPaginated: {
    detections: Array<{
      detection_id: string;
      tenant: string;
    }>;
    total_items: number;
  };
}

export const useQueryDetectionIds = (
  options?: LazyQueryHookOptions<
    QueryDetectionIdsResponse,
    QueryDetectionIdsVariables
  >,
) => {
  return useLazyQuery<QueryDetectionIdsResponse, QueryDetectionIdsVariables>(
    QUERY_DETECTION_IDS,
    options,
  );
};
